export default __webpack_public_path__ + "static/media/trade.f4b71285.svg";